import { AuthContext } from '../components/Context/AuthContext';
import { Modal, message } from 'antd';
import axios from 'axios';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';


const SYSTEM_ERROR = 'System error. Please try again later!';

//axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

function restApiOptions(METHOD, PAYLOAD) {
  switch (METHOD) {
    case 'GET':
      return {
        params: { ...PAYLOAD },
      };
    case 'POST':
    case 'PATCH':
      return {
        data: PAYLOAD,
      };
    case 'PUT':
      return {
        data: PAYLOAD,
      };
    case 'DELETE':
      return {};
    default:
      return {
        params: { ...PAYLOAD },
      };
  }
}

export function useFetch() {
  let navigate = useNavigate();

  const auth = useContext(AuthContext);
  const userToken = auth.userToken;
  const logout = auth.handleLogout;
  let count = 0;
  // axios.defaults.headers.common['Authorization'] = userToken;


  async function fetchApi(API, METHOD = 'GET', PAYLOAD = {}, headers = {}, restOptions = {}) {
    return new Promise((resolve, reject) => {
      try {
        axios({
          method: METHOD,
          url: API,
          headers: {
            'Authorization': !userToken ? null : `Bearer ${userToken}`,
            'x-api-key': 'ABCD-123',
            ...headers
          },
          ...restOptions,
          ...restApiOptions(METHOD, PAYLOAD),
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            const response = err.response;
            reject(response);

            if (response.statusText) {
              if (response.data?.data?.error !== undefined) {
                message.error(response.data.data.error);
              }
              else {
                message.error(response.statusText);
              }
            }

            else {
              message.error('Error while performing this action, Please try again!')
            }

            const statusCode = err.response.status;
            //console.log(statusCode);

            if (statusCode === 401) {
              if (userToken) {
                if (count === 0) {
                  Modal.warning({
                    title: 'Session Timedout',
                    content: 'Please use logout button to go back and login again.',
                    okText: 'Logout',
                    onOk: logout,
                    closable: false,
                    keyboard: false,
                  })
                }
                count = count + 1;
              }
            } else if (statusCode == 500) {
              //Handle 500
            }
          });
      } catch (error) {
        // console.error("Error in Promise, ", error);
        reject(SYSTEM_ERROR);
      }
    });
  }

  return { fetchApi };
}
